import { EntityField } from './EntityField';
import { DataType } from './eDataType';

export class ArrayEntitieFields {
  List: EntityField[];
  DictValues: { [key: string]: EntityField };

  constructor() {
    this.List = new Array<EntityField>();
    this.DictValues = {};
  }


  addEntityField(entity: any): void {
    var entField;
    entity.type = entity.type ? entity.type : DataType.VARCHAR2;
    if (entity.Value !== null && entity.Value !== undefined) {
      if (entity.Value.constructor !== Array) {
        if (entity.Type === DataType.DATE) {
          this.List.push(this.parseDate(entity));
        } else {
          entity.Value = (entity.Value !== "") ? entity.Value : null;
          entField = new EntityField(entity.Name, entity.Value, entity.type);
          this.List.push(entField);
        }
      } else {
        entity.Value[0] = (entity.Value[0] !== "") ? entity.Value[0] : null;
        entField = new EntityField(entity.Name, entity.Value[0], entity.type);
        this.List.push(entField);
      }
    } else {
      entField = new EntityField(entity.Name, null, entity.type);
      this.List.push(entField);
    }
  }

  parseDate(entity: EntityField) {
    let date = (entity.Value === '') ? '' : entity.Value.split('/');
    if (date !== '' && date.length > 1) {
      let auxFormat = "dd/mm/yyyy".split('/');
      let dbDate = '';
      for (let val of 'yyyy/mm/dd'.split('/')) {
        let i = 0;
        for (i; i < auxFormat.length; i++) {
          if (val === auxFormat[i])
            break
        }
        // if (val === 'dd')
        dbDate += date[i];
      }
      entity.Value = dbDate;
    }
    return entity;
  }
}